import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView'
import LoginSSOView from '../views/LoginSSOView'
import MainView from '../views/MainViewVer'
import HomeView from '../views/HomeView'
import CaseApplyManage from '../components/CaseApplyManageView'
// import SchoolCityManage from '../components/SchoolCityManageView'
// import AddGeneralMember from '../components/AddGeneralMemberView'
// import EditGeneralMemberView from '../components/EditGeneralMemberView'
// import AddEnterpriseMemberView from '../components/AddEnterpriseMemberView'
// import EditEnterpriseMemberView from '../components/EditEnterpriseMemberView'
import PersonalInformation from '../components/PersonalInformationView'
import AddNewCase from '../components/AddNewCaseView'
import index from '../components/index'
import StdLoginView from '../components/StdLoginView'
import ForbiddenComponent from '../components/exceptions/403'
import NoFoundComponent from '../components/exceptions/404'
import ErrorComponent from '../components/exceptions/500'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: index },
  { path: '/index', component: index },
  // { path: '/AllCourse', component: AllCourseView },
  {
    path: '/StdLogin',
    name: 'StdLogin',
    component: StdLoginView
   },
   {
    path: '/home',
    name: 'Home',
    component: HomeView
   },
  {path: '/CaseApplyManage',name: 'CaseApplyManage',component: CaseApplyManage},
  { path: '/PersonalInformation', name:'PersonalInformation',component: PersonalInformation },
  { path: '/AddNewCase', name:'AddNewCase',component: AddNewCase },
  //{ path: '/AddEnterpriseMember', component: AddEnterpriseMemberView },
  // { path: '/EditGeneralMember/:IdNo/:PsWord',name: 'EditGeneralMember', component: EditGeneralMemberView, props: true },
  //{ path: '/EditGeneralMember',name: 'EditGeneralMember', component: EditGeneralMemberView, props: true },
 // { path: '/EditEnterpriseMember/:IdNo/:PsWord',name: 'EditEnterpriseMember', component: EditEnterpriseMemberView, props: true  },
  //{ path: '/EditEnterpriseMember',name: 'EditEnterpriseMember', component: EditEnterpriseMemberView, props: true  },

  // { path: '/CheckLogin', component: CheckLoginView },


//   {
//   path: '/Active/:num?',
//   name: 'Active',
//   component: IdActiveView
//  },
     {
      path: '/login',
      name: 'Login',
      component: LoginView
    },
    {
      path: '/loginsso',
      name: 'Loginsso',
      component: LoginSSOView
    },
    {
    path: '/main',
    name: 'Main',
    component: MainView
  },
  {
    path: '/403',
    component: ForbiddenComponent,
    name: 'forbidden'
  },
  {
    path: '/404',
    component: NoFoundComponent,
    name: 'noFound'
  },
  {
    path: '/500',
    component: ErrorComponent,
    name: 'error'
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
